import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';
import { saveWithExpiration, getWithExpiration } from 'helpers/localstorage';
import { getGuardianStudentPlans } from 'actions/planning';
import ReactGantt from 'containers/Gantt/ReactGantt';
import LoadingCards from 'components/Presentation/Cards/LoadingCards';
import SectionTitle from 'components/Presentation/SectionTitle';
import { Icon, Button, translate, getActiveLanguage } from '@haldor/ui';
var MyPlanning = /*#__PURE__*/function (_Component) {
  function MyPlanning(props) {
    var _this;
    _classCallCheck(this, MyPlanning);
    _this = _callSuper(this, MyPlanning, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      if (_this.props.plans == null) {
        _this.props.getGuardianStudentPlans(_this.props.activeStudent.id).then(function () {
          _this.parseRows(_this.props.plans);
        });
      } else if (_this.props.plans != null) {
        _this.parseRows(_this.props.plans);
        _this.props.getGuardianStudentPlans(_this.props.activeStudent.id).then(function () {
          _this.parseRows(_this.props.plans);
        });
      }
    });
    _defineProperty(_this, "parseRows", function (plans) {
      var rows = _this.state.rows;
      var groups = _this.state.groups;
      rows = [];
      if (plans != null) {
        plans.map(function (planning) {
          var isInGroups = groups.find(function (g_o) {
            return g_o.id == planning.sectionId;
          });
          if (_this.props.groupid && planning.sectionId != parseInt(_this.props.groupid)) {
            return false;
          }
          if (!isInGroups) {
            var newGroup = {
              id: planning.sectionId,
              title: planning.section.title,
              open: false,
              showGroupTitle: true
            };
            groups.push(newGroup);
          }
          var newRow = {
            title: planning.title,
            id: planning.id,
            borderLeft: "3px solid #997AE8",
            startDate: moment(planning.timeStart).toDate(),
            climaxDate: moment(planning.timeStart).add('6', 'hours').toDate(),
            endDate: moment(planning.timeEnd).toDate(),
            group: planning.sectionId,
            planning: planning,
            action: function action() {
              _this.props.history.push("/plan/".concat(planning.id));
            }
          };
          if (_this.props.dateRestriction && planning.status != 'PLANNING_CLOSED') {
            rows.push(newRow);
          } else if (_this.props.dateRestriction == false) {
            rows.push(newRow);
          }
        });
      }
      _this.setState({
        groups: groups,
        rows: rows
      }, function () {
        return true;
      });
    });
    _defineProperty(_this, "toggleIcon", function (flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? "i-90" : "a-90",
        style: {
          height: "7px",
          width: "15px"
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });
    _defineProperty(_this, "goToday", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var momentDate = moment();
      options.leftBound = momentDate.startOf('week').toDate();
      options.rightBound = momentDate.endOf('week').add(3, 'weeks').toDate();
      localStorage.removeItem('gantt-leftbound');
      localStorage.removeItem('gantt-rightbound');
      _this.setState({
        options: options
      });
    });
    _defineProperty(_this, "goBackwards", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var leftBound = moment(options.leftBound).subtract('1', 'weeks').toDate();
      var maxLeftBound = moment().startOf('week').subtract('20', 'weeks').toDate();
      if (leftBound > maxLeftBound || _this.props.dateRestriction == false) {
        options.leftBound = leftBound;
        options.rightBound = moment(options.rightBound).subtract('1', 'weeks').toDate();
        saveWithExpiration('gantt-leftbound', options.leftBound);
        saveWithExpiration('gantt-rightbound', options.rightBound);
        _this.setState({
          options: options
        });
      }
    });
    _defineProperty(_this, "goForwards", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var rightBound = moment(options.rightBound).add('1', 'weeks').toDate();
      var maxRightBound = moment().endOf('week').add('4', 'weeks').add('20', 'weeks').toDate();
      if (rightBound < maxRightBound || _this.props.dateRestriction == false) {
        options.leftBound = moment(options.leftBound).add('1', 'weeks').toDate();
        options.rightBound = rightBound;
        saveWithExpiration('gantt-leftbound', options.leftBound);
        saveWithExpiration('gantt-rightbound', options.rightBound);
        _this.setState({
          options: options
        });
      }
    });
    var _momentDate = moment();
    var _leftBound = _momentDate.startOf('week').toDate();
    var _rightBound = _momentDate.endOf('week').add(3, 'weeks').toDate();
    if (getWithExpiration('gantt-leftbound') != null) {
      _leftBound = moment(getWithExpiration('gantt-leftbound')).toDate();
    }
    if (getWithExpiration('gantt-rightbound') != null) {
      _rightBound = moment(getWithExpiration('gantt-rightbound')).toDate();
    }
    _this.state = {
      modalIsOpen: false,
      rows: null,
      groups: [],
      options: {
        labelWidth: '20%',
        labelBorderColor: '#E4E4EB',
        labelAppendBeforeFormat: 'Vecka',
        intervalFormat: 'W',
        showBorders: false,
        responsive: true,
        bootstrapped: true,
        leftBound: _leftBound,
        rightBound: _rightBound,
        placeholder: '',
        beforeClimaxColor: 'white',
        afterClimaxColor: 'white',
        hideFirstColumn: true,
        barStyle: {
          height: '120px',
          border: '1px solid #E4E4EB',
          showTitle: true,
          shadow: false,
          borderRadius: '4px',
          hoverPopup: false,
          showGroupTitle: true
        }
      }
    };
    return _this;
  }
  _inherits(MyPlanning, _Component);
  return _createClass(MyPlanning, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.plans != null) {
        this.parseRows(nextProps.plans);
      } else {
        this.setState({
          groups: [],
          rows: null
        }, function () {
          return true;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        rows = _this$state.rows,
        groups = _this$state.groups,
        options = _this$state.options;
      var plans = this.props.plans;
      return /*#__PURE__*/React.createElement("div", {
        className: "section",
        id: "section-planning",
        style: {
          margin: 0,
          padding: 0,
          border: 0,
          zIndex: 10,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "my_planning planning"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, this.props.dateRestriction || this.props.overview ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plans"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate('Plans')), rows != null && rows.length > 0 ? /*#__PURE__*/React.createElement(Link, {
        to: "/plans",
        className: "see-more"
      }, this.props.translate('Show all plans')) : "") : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0,
          marginRight: '0.5em'
        },
        onClick: this.goBackwards
      }, this.toggleIcon(false), "\xA0"), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0,
          marginRight: '0.5em'
        },
        onClick: this.goToday
      }, this.props.translate('Today')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0
        },
        onClick: this.goForwards
      }, this.toggleIcon(true), "\xA0")), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }))), plans != null && rows != null && rows.length == 0 && plans.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          fontWeight: "500",
          color: "#9f9f9f",
          backgroundColor: "white",
          padding: "2rem",
          boxShadow: "0 5px 15px #0000000d",
          borderRadius: "3px"
        }
      }, this.props.translate('There is nothing planned')) : rows != null && rows.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "gantt-container"
      }, this.props.sections != null ? /*#__PURE__*/React.createElement(ReactGantt, {
        options: options,
        groups: groups,
        rows: rows,
        sections: this.props.sections,
        weekTranslation: 'V'
      }) : /*#__PURE__*/React.createElement(LoadingCards, {
        count: 1
      })) : /*#__PURE__*/React.createElement(LoadingCards, {
        count: 1
      })));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    plans: state.planning.plans,
    sections: state.groups.groups,
    translate: translate(state.Languages.translations)
  };
};
export default withRouter(connect(mapStateToProps, {
  getGuardianStudentPlans: getGuardianStudentPlans
})(MyPlanning));